import { BackendModel, BackendService } from '../core/backend.service';
import { Email } from '../security/user/email.model';
import { Sector } from './sectores/sector.model';
export class Subcliente extends BackendModel {

    public static path = '/subclientes/';

    id: number;
    username: string;
    password: string;
    retryPassword: string;
    clientePadreId: number;
    sector: Sector;
    email: Email;
    montoMax: number;
    idTipoMontoMax: number;
    enable: boolean;
    pagaEnvio: boolean;

    
    constructor(protected backendService: BackendService, model?: Subcliente) {
        super(backendService, model);
      }
}



// WEBPACK FOOTER //
// ./src/app/cliente/subcliente.model.ts